import React from 'react';

interface InputErrorProps {
    children?: React.ReactNode;
    error?: string | string[] | null;
}

const InputError: React.FC<InputErrorProps> = ({ children, error }) => {
    const message = children || (error ? (Array.isArray(error) ? error[0] : error) : null);
    
    if (!message) {
        return null;
    }

    return (
        <p className="mt-1 text-xs text-red-500">
            {message}
        </p>
    );
};

export default InputError;
